if (!customElements.get('subscription-swap-widget')) {
  customElements.define(
    'subscription-swap-widget',
    class SubscriptionSwapWidget extends HTMLElement {
      constructor() {
        super();

        this.oneTimeVariantId = this.dataset.oneTimeVariantId;
        this.oneTimeAvailable = this.dataset.oneTimeAvailable === 'true';
        this.subscriptionVariantId = this.dataset.subscriptionVariantId;
        this.subscriptionAvailable = this.dataset.subscriptionAvailable === 'true';

        this.quantityInput = this.querySelector('.quantity__input');
        this.errorWrapper = this.querySelector('.subscription-swap-widget__error-message-wrapper');
        this.errorMessage = this.querySelector('.subscription-swap-widget__error-message');

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        this.querySelectorAll('[data-mode-input]').forEach((input) =>
          input.addEventListener('change', this.onModeChange.bind(this))
        );

        this.querySelector('[data-action="add-to-cart"]').addEventListener(
          'click',
          this.onSubmit.bind(this, false)
        );
        this.querySelector('[data-action="buy-now"]').addEventListener('click', this.onSubmit.bind(this, true));

        this.onModeChange();
      }

      get selectedMode() {
        return this.querySelector('[data-mode-input]:checked')?.dataset.modeInput || 'one_time';
      }

      get selectedPlanId() {
        return this.querySelector('.subscription-swap-widget__plan-input:checked')?.value || null;
      }

      onModeChange() {
        const isSubscription = this.selectedMode === 'subscription';
        const intervals = this.querySelector('[data-intervals]');
        if (intervals) intervals.toggleAttribute('hidden', !isSubscription);
        this.querySelectorAll('.subscription-swap-widget__option').forEach((option) => {
          const mode = option.querySelector('[data-mode-input]')?.dataset.modeInput;
          option.classList.toggle('is-checked', mode === this.selectedMode);
        });
      }

      buildItem() {
        const quantity = parseInt(this.quantityInput.value, 10) || 1;

        if (this.selectedMode === 'subscription') {
          if (!this.subscriptionAvailable) return null;
          const sellingPlan = this.selectedPlanId;
          if (!sellingPlan) return null;
          return { id: this.subscriptionVariantId, quantity, selling_plan: sellingPlan };
        }

        if (!this.oneTimeAvailable) return null;
        return { id: this.oneTimeVariantId, quantity };
      }

      async onSubmit(isBuyNow) {
        if (this.submitting) return;
        this.submitting = true;

        const item = this.buildItem();
        if (!item) {
          this.handleErrorMessage('選択した内容は現在ご購入いただけません。');
          this.submitting = false;
          return;
        }

        this.handleErrorMessage();
        this.toggleLoading(true);

        const body = { items: [item] };
        if (this.cart) {
          body.sections = this.cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }

        try {
          const response = await fetch(`${window.routes.cart_add_url}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
          const data = await response.json();

          if (data.status) {
            this.handleErrorMessage(data.description || data.message);
            return;
          }

          if (isBuyNow) {
            window.location.href = '/checkout';
            return;
          }

          if (this.cart) {
            this.cart.setActiveElement?.(document.activeElement);
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'subscription-swap-widget',
              productVariantId: item.id,
              cartData: data,
            });
            this.cart.renderContents(data);
          } else {
            window.location.href = window.routes.cart_url;
          }
        } catch (error) {
          console.error(error);
          this.handleErrorMessage('カートへの追加に失敗しました。時間をおいて再度お試しください。');
        } finally {
          this.toggleLoading(false);
          this.submitting = false;
        }
      }

      toggleLoading(isLoading) {
        this.querySelectorAll('.subscription-swap-widget__buttons button').forEach((button) => {
          button.toggleAttribute('aria-disabled', isLoading);
          button.classList.toggle('loading', isLoading);
          button.querySelector('.loading__spinner')?.classList.toggle('hidden', !isLoading);
        });
      }

      handleErrorMessage(message = false) {
        if (!this.errorWrapper) return;
        this.errorWrapper.toggleAttribute('hidden', !message);
        if (message) this.errorMessage.textContent = message;
      }
    }
  );
}
